module.exports = __webpack_public_path__ + "img/photo1.95aba975.png";